<script>
import { mapActions, mapState, mapGetters } from "vuex";

import cycleMixin from "@/mixins/cycleMixin";

import Payable from "../Payable/Index";
import Payment from "../Payment/Payment";
import Success from "../Success";

export default {
  mixins: [cycleMixin],

  components: {
    Payable,
    Payment,
    Success
  },

  methods: {
    ...mapActions("payable", [
      "reset",
      "getPayable",
      "getStoredCreditCards",
      "setErrorOnPayment"
    ]),

    async setPayable() {
      const validPayable = await this.getPayable({
        id: this.getPayableId(),
        type: "cycle"
      });

      if (!validPayable) {
        this.$router.push({ name: "dashboard" });
        return;
      }

      if (!this.canGoToCheckout(this.payable)) {
        this.$router.push({
          name: "cycle",
          params: { id: this.getPayableId() }
        });
      }

      if (!this.isCyclePayable(this.payable)) {
        const errorMessage = this.getReasonForInabilityToPay(this.payable);

        await this.setErrorOnPayment(errorMessage);
      }
    },

    async setStoredCreditCards() {
      await this.getStoredCreditCards();
    },

    getPayableId() {
      return this.$route.params.cycle_id;
    }
  },

  computed: {
    ...mapState("payable", ["payable"]),
    ...mapGetters("payable", ["payablePaid"])
  },

  async mounted() {
    await this.reset();
    await this.setPayable();
    await this.setStoredCreditCards();
  },

  async beforeDestroy() {
    await this.reset();
  }
};
</script>
<template>
  <div class="container">
    <transition-group name="zoom" mode="out-in">
      <div key="success" v-if="payablePaid">
        <Success class="card" :payable="payable" />
      </div>

      <div key="payment" v-else>
        <Payable />
        <Payment />
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.container {
  max-width: 720px;
  margin: 0 auto;
}

.left {
  width: 70%;
}

.right {
  width: calc(30% - 10px);
}

@media (max-width: 992px) {
  .left,
  .right {
    width: 100%;
  }

  .row {
    flex-direction: column !important;
  }
}

@media (max-width: 540px) {
  .right {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Cycle/Index.vue